import { render, staticRenderFns } from "./my-documents-modal.component.vue?vue&type=template&id=605b4e52&"
import script from "./my-documents-modal.component.vue?vue&type=script&lang=ts&"
export * from "./my-documents-modal.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports